<template>
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="card mb-4">
            <h5>Profile Details</h5>
            <div class="card-body">
                <div class="d-flex align-items-start align-items-sm-center gap-4">
                    <img :src="avatar" alt="user-avatar" class="d-block rounded" height="100" width="100" id="uploadedAvatar" />
                    <div class="button-wrapper">
                        <label for="upload" class="btn btn-primary me-2 mb-4" tabindex="0">
                            <span class="d-none d-sm-block">Upload new photo</span>
                            <i class="bx bx-upload d-block d-sm-none"></i>
                            <input type="file" id="upload" class="account-file-input" hidden accept="image/png, image/jpeg" />
                        </label>
                        <button type="button" class="btn btn-outline-secondary account-image-reset mb-4">
                            <i class="bx bx-reset d-block d-sm-none"></i>
                            <span class="d-none d-sm-block">Reset</span>
                        </button>

                        <p class="text-muted mb-0">Allowed JPG, GIF or PNG. Max size of 800K</p>
                    </div>
                </div>
            </div>

            <hr class="my-0" />
            
            <div class="card-body">
                <form id="formAccountSettings" method="POST" onsubmit="return false">
                    <div class="row">
                        <div class="mb-3 col-md-6">
                            <label for="first_name" class="form-label">First Name</label>
                            <input class="form-control" v-model="profile.first_name" autofocus />
                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="last_name" class="form-label">Last Name</label>
                            <input class="form-control" v-model="profile.last_name"  />
                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="email" class="form-label">E-mail</label>
                            <input class="form-control" v-model="profile.email"/>
                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="display_name" class="form-label">Display Name</label>
                            <input class="form-control" v-model="profile.display_name"/>
                        </div>

                        <div class="mb-3 col-md-6">
                            <label for="phone" class="form-label">Phone</label>
                            <input class="form-control" v-model="profile.phone"/>
                        </div>
                        <div class="mb-3 col-md-6">
                            <label for="company_name" class="form-label">Company Name</label>
                            <input class="form-control" v-model="profile.company_name"/>
                        </div>
                        
                    </div>
                    <div class="mt-2">
                        <button type="submit" class="btn btn-primary me-2">Save changes</button>
                        <button type="reset" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </form>
            </div>
            <!-- /Account -->
        
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                avatar: require('@/assets/images/avatar-empty.png'),
                profile: [],
                loading: true,
                error: null,
                pollingInterval: null
                
            };
        },
        created() {
            this.fetchProfileData();
        },
        mounted() {
            // Start polling every 10 seconds
            this.pollingInterval = setInterval(() => {
                this.fetchProfileData();
            }, 10000);
        },
        beforeUnmount() {
            // Clear polling when component is destroyed
            clearInterval(this.pollingInterval);
        },
        methods: {
            fetchProfileData() {
                const customerId = localStorage.getItem('customerId');
                if(customerId != undefined){
                    axios.get('/api/zoho/customer-detail/' + customerId)
                    .then(response => {
                        let data = response.data;
                        this.profile = data.customer;
                    })
                    .catch(() => {
                        this.error = 'Failed to fetch profile.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                }
            }

        },
    };
</script>

<style scoped>
    h1 {
        color: #42b983;
    }
</style>
